export enum FetchStates {
  UNFETCHED = 'UNFETCHED',
  FETCHING = 'FETCHING',
  FETCHED = 'FETCHED',
}
